import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const newsletterData = {
  "2026-2027": [
    {
      title: "SPCS Campus",
      link: "https://online.fliphtml5.com/gusfm/SPCS-CAMPUS-CANVAS-BnMf/",
      image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/SPCS-CAMPUS-CANVAS.JPG",
    }
  ],
  "2025-2026": [
    {
      title: "Art Edition",
      link: "https://online.fliphtml5.com/owuse/art-magazine/",
      image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/epistle_artEdition_2026.PNG",
    },
    {
      title: "Sports Magazine",
      link: "https://online.fliphtml5.com/owuse/wneq/",
      image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/sportMag_2026.PNG",
    },
    {
      title: "Creative Corner",
      link: "https://online.fliphtml5.com/owuse/creative-corner/",
      image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/peterian_let_their_creativity_fly_2026.PNG",
    },
    {
      title: "Co-Curricular & Curricular Activities",
      link: "https://online.fliphtml5.com/owuse/co-curricular-and-curricular-activities/",
      image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/assemblies_2026.PNG",
    },
  ],
  "2024-25": [
    {
      title: "Learning Today,Leading Tomorrow",
      link: "https://drive.google.com/file/d/1AadqGB5QQZ4cv6KuTvxOI_iLKIcTwm1D/view?usp=drive_link",
      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/newsletter_2.JPG",
    },
    {
      title: "Little Steps Big dreams 2024-25",
      link: "https://drive.google.com/file/d/15X8EoUWe1fRwFfbmVc9f9g396qewrJS2/view",
      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Newsletter1.jpg",
    },
  ],
};

const Newsletter = () => {
  const yearOptions = Object.keys(newsletterData);
  const [selectedYear, setSelectedYear] = useState(yearOptions[0] || "");
  const selectedItems = newsletterData[selectedYear] || [];

  useEffect(() => {
    document.title = "Newsletter -  St Peters convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Newsletter</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 col-md-7 col-12">
              <h1>Newsletter</h1>
            </div>
            <div className="col-lg-4 col-md-5 col-12">
              <div className="year-filter-box d-flex align-items-center justify-content-md-end">
                <h3 className="mb-0 me-2">Select Year</h3>
                <select
                  className="form-control"
                  style={{ maxWidth: "180px" }}
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  {yearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="row">
            {selectedItems.map((item, index) => (
              <div
                className="col-xl-4 col-lg-6 col-md-6 col-sm-12 videosearch"
                key={`${selectedYear}-${index}`}
              >
                <div className="video-gallery">
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <LazyLoad>
                      <img
                        src={item.image}
                        alt={item.title}
                        className="img-fluid"
                      />
                    </LazyLoad>
                    <div>
                      <h3>{item.title}</h3>
                    </div>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Newsletter;




